export const RECEIVE_PROFILE_DATA = "RECEIVE_PROFILE_DATA";
export const RECEIVE_BIO_DATA = "RECEIVE_BIO_DATA";
export const REQUEST_PROFILE_DATA = "REQUEST_PROFILE_DATA";
export const REQUEST_BIO_DATA = "REQUEST_BIO_DATA";
export const REQUEST_PROFILE_DATA_SYNC = "REQUEST_PROFILE_DATA_SYNC";
export const REQUEST_PROFILE_DATA_UPDATE = "REQUEST_PROFILE_DATA_UPDATE";
export const REQUEST_BIO_DATA_UPDATE = "REQUEST_BIO_DATA_UPDATE";

export function receiveProfileData() {
	return {
		type: RECEIVE_PROFILE_DATA,
	};
}

export function receiveBioData() {
	return {
		type: RECEIVE_BIO_DATA,
	};
}

export function requestProfileData() {
	return {
		type: REQUEST_PROFILE_DATA,
	};
}

export function requestProfileUpdate() {
	return {
		type: REQUEST_PROFILE_DATA_UPDATE,
	};
}

export function requestBioData() {
	return {
		type: REQUEST_BIO_DATA,
	};
}

export function requestBioUpdate() {
	return {
		type: REQUEST_BIO_DATA_UPDATE,
	};
}

